import React from 'react';
import packageJson from '../package.json';
import { clearLocalStorage } from "./functions";
import moment from "moment";

// version from response - first param, local version second param
const semverGreaterThan = (latestDate, currentDate) => {
	const momLatestDateTime = moment(latestDate);
	const momCurrentDateTime = moment(currentDate);
	
	return momLatestDateTime.isAfter(momCurrentDateTime);
};

class CacheBuster extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			isLatestVersion: false,
			refreshCacheAndReload: () => {
				console.log('Clearing cache and hard reloading...');
				clearLocalStorage();
				window.location.reload();
			}
		};
	}
	
	componentWillMount() {
		this.clearCache();
	}
	
	clearCache = () => {
		const metaBuildate = JSON.parse(localStorage.getItem('timeBuild'));
		
		const appBuildDate = packageJson.buildDate;
		
		if (metaBuildate !== appBuildDate) {
			localStorage.setItem('timeBuild', appBuildDate);
			this.setState({ loading: false, isLatestVersion: false });
		}
	};
	
	componentDidMount() {
		const latestVersion = JSON.parse(localStorage.getItem('timeBuild'));
		const currentVersion = packageJson.buildDate;
		
		const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
		if (shouldForceRefresh) {
			console.log(`We have a new version - ${latestVersion}. Should force refresh`);
			this.setState({ loading: false, isLatestVersion: false });
		} else {
			console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
			this.setState({ loading: false, isLatestVersion: true });
		}
	}
	
	render() {
		const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
		if (loading) return null;
		if (!loading && !isLatestVersion) {
			refreshCacheAndReload();
		}
		return this.props.children;
	}
}

export default CacheBuster;
